import axios from "axios";
import store from "@/store";

const httpClient = axios.create({
  baseURL: `${import.meta.env.VITE_VUE_APP_API_URL}/api/admin`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-origin": import.meta.env.VITE_VUE_APP_ORIGIN,
  },
  validateStatus: function (status) {
    if (status === 401) store.dispatch("auth/logout");
    return status >= 200 && status < 300;
  },
});

httpClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      error.response.data.errors =
        error.response?.data?.errors ||
        error.response?.data?.message ||
        "An error occurred";
    }
    return Promise.reject(error);
  }
);

export default httpClient;
